import React from "react";
import ProfileImage from "../assets/profileimg1.jpeg";

const About = () => {
  return (
    <>
      <div id="aboutme">
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl pt-10">
          🙋‍♂️ About me
        </h2>
        <section className="mx-auto h-auto lg:h-screen flex-row-reverse max-w-screen-xl pb-4 px-4 items-center lg:flex md:px-8 mt-20 xl:mt-0">
          <div className="flex flex-1 text-center justify-center align-center mt-4 lg:mt-2 xs:mt-14 lg:ml-3">
            <img
              src={ProfileImage}
              className="w-2/5 h-2/5 lg:w-3/4 lg:h-3/4 rounded-xl"
              alt="profile"
            />
          </div>

          <div className=" mt-20 space-y-2 flex-1 xs:text-center lg:text-left md:mt-0">
            <h1 className="px-2 xs:p-2 text-2xl sm:mt-10 text-white font-bold xs:text-2xl sm:text-3xl xl:text-5xl mb-4">
              Hola, I am
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500">
                {" "}
                Mukka Deepak{" "}
              </span>
            </h1>
            <p className="px-2 xs:p-4 text-gray-300 max-w-lg md:text-lg xs:max-w-3xl text-sm xs:text-base leading-relaxed sm:mx-auto lg:ml-0 text-justify">
              I have completed my graduation from VIT Vellore, where I pursued
              Computer Science and Engineering. My journey into programming
              began during my freshman year, where I started with learning the
              fundamental C programming language. This foundation was invaluable
              in helping me grasp the core concepts of programming. As I
              progressed, I delved into C++ and was introduced to the world of
              Object-Oriented Programming (OOP).
              <br />
              <br />I have started with HTML, CSS and Javascript, after doing
              some projects and writing some blogs, finally I have gained enough
              experience to build interactive websites. Later, I have been
              intoduced to ReactJS with which building a modern web application
              became lot easier and faster.{" "}
              <strong className="underline text-[#d4dcff]">
                After completing internship in 3 companies
              </strong>
              &nbsp; as a software developer and front end developer, now I am
              confident in developing websites and also started to learn backend
              development with Nodejs, MongoDB and MYSQL.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;